// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"364f2cac","498":"e33f32da","703":"1b45b9c5"}[chunkId] + ".chunk.js";
};